<template>
    <div class="global_view_forum" :class="{ dark }">
      <v-container class="forum-container">
  
        <v-container v-if="loading" class="d-flex align-center justify-center" style="height: 90vh">
          <v-progress-circular
            indeterminate
            color="#42cfd7"
            size="48"
          ></v-progress-circular>
        </v-container>
  
        <!-- FÓRUM -->
        <v-card v-if="forum && !loading" class="forum-card" id="forum_view_card">
          <div class="forum-header">
            <h1 class="forum-title">{{ forum.title }}</h1>
            <div class="forum-meta">
              <small>Postado por <strong>{{ forum.userName }}</strong> em {{ formatDate(forum.dateInsert) }}</small>
            </div>
          </div>
          <v-card class="forum-description" flat id="forum_view_description">
            <v-card-text>
              {{ forum.description }}
            </v-card-text>
          </v-card>
          <div class="info_forum">
            <span>{{ comments.length }} comentário{{ comments.length == 1 ? '' : 's' }}</span>
          </div>
        </v-card>
  
        <!-- COMENTÁRIOS -->
        <v-card class="forum-comments" v-if="!loading" id="forum_view_comments">
          <div v-if="comments.length" class="comments-list">
            <div
              v-for="comment in comments"
              :key="comment.id"
              class="comment-box"
            >
              <div class="comment-header">
                <div class="avatar">{{ getInitials(comment.userName) }}</div>
                <div class="comment-info_user">
                  <strong>
                    {{
                      comment.userName.length > 12
                        ? comment.userName.slice(0, 12) + '...'
                        : comment.userName
                    }}
                  </strong>
                  <div class="comment-date">{{ formatDate(comment.dateInsert) }}</div>
                </div>
                <div class="comment-body" v-html="comment.comment"></div>
              </div>
              <div class="comment-info_user_mobile">
                <small>{{ formatDate(comment.dateInsert) }} - {{ comment.userName }}</small>
              </div>
            </div>
          </div>
          <div v-else class="no-comments">
            Nenhum comentário ainda. Seja o primeiro a comentar!
          </div>
  
          <v-divider class="my-4" />
  
          <!-- NOVO COMENTÁRIO -->
          <div class="comment-form">
            <v-textarea
              v-model="commentText"
              variant="outlined"
              :bg-color="dark ? '#202020' : '#fff'"
              :color="dark ? '#fff' : '#000'"
              rows="4"
              hide-details
              id="forum_view_comment_text"
              placeholder="Escreva seu comentário"
            />
            <v-btn
              color="#19c7d0"
              @click="sendComment"
              :disabled="!commentText || loadingSend"
              class="mt-2"
              id="forum_view_send_comment"
            >
              <v-progress-circular
                v-if="loadingSend"
                indeterminate
                color="white"
                size="20"
                class="mr-2"
              ></v-progress-circular>
              Enviar
            </v-btn>
          </div>
        </v-card>
      </v-container>
    </div>
  </template>
  
<script>
import api from '@/utils/portal/forum.js'
import { mapState } from 'vuex'
import { toast } from 'vue3-toastify';


export default {
  data() {
    return {
      forum: null,
      comments: [],
      commentText: '',
      loading: false,
      loadingSend: false
    }
  },
  computed: {
    ...mapState(['token','dark'])
  },
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    getInitials(name) {
      return name
        .split(' ')
        .map(n => n[0])
        .join('')
        .slice(0, 2)
        .toUpperCase()
    },
    async fetchForum() {
      const id = this.$route.params.slug
      this.loading = true
      try {
        const forums = await api.getDataForum(this.token)
        this.forum = forums.find(f => f.id == id)
        await this.fetchComments()
      } catch (e) {
        toast.error('Erro ao carregar fórum')
        console.error('Erro ao carregar fórum:', e)
      } finally {
        this.loading = false
      }
    },
    async fetchComments() {
      try {
        this.comments = await api.getCommentsByForumId(this.token, this.forum.id)
      } catch (e) {
        console.error('Erro ao carregar comentários:', e)
      }
    },
    async sendComment() {
      if (!this.commentText) return
      this.loadingSend = true
      try {
        await api.newComment(this.token, {
          comment: this.commentText,
          idForum: this.forum.id
        })
        this.commentText = ''
        await this.fetchComments()
        // Após salvar, rola para o topo da tela
        window.scrollTo({ top: 0, behavior: 'smooth' })
      } catch (e) {
        console.error('Erro ao enviar comentário:', e)
      } finally {
        this.loadingSend = false
      }
    }
  },
  mounted() {
    this.fetchForum()
  }
}
</script>

<style>
@import './css/forumView.css';
</style>
